<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: 'min(800px, 95vw)' }"
  [breakpoints]="{ '960px': '95vw', '640px': '100vw' }"
  [header]="tituloHeader"
  styleClass="n-dialog"
  (onHide)="fechar()"
>
  <!-- Loading State -->
  @if ($loading()) {
  <div class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <p>{{"PESSOAS_MODAL_DETALHE.CARREGANDO_DADOS" | translate}}</p>
  </div>
  }

  <!-- TabView -->
  @if (!$loading()) {
  <p-tabView>
    <!-- ===== TAB 1: Dados Pessoais ===== -->
    <p-tabPanel [header]="dadosPessoaisHeader">
      @if ($pessoa(); as pessoa) {
      <div class="dados-pessoais-container">
        <!-- Avatar -->
        <div class="avatar-section">
          @if ($imagemUrl()) {
          <img [src]="$imagemUrl()" alt="Foto de perfil" class="avatar-img" />
          } @else {
          <p-avatar icon="pi pi-user" size="xlarge" shape="circle"></p-avatar>
          }
        </div>

        <!-- Dados Principais -->
        <div class="dados-grid">
          <div class="campo">
            <span class="campo-label">{{"GLOBAL.NOME" | translate}}</span>
            <p>{{ pessoa.nome }}</p>
          </div>

          <div class="campo">
            <span class="campo-label">{{"GLOBAL.CPF_CNPJ" | translate}}</span>
            <p>{{ pessoa.cpfCnpj ? formatarCPFOUCNPJ(pessoa.cpfCnpj) : '-' }}</p>
          </div>

          <div class="campo">
            <span class="campo-label">{{"GLOBAL.EMAIL" | translate}}</span>
            <p>{{ pessoa.email }}</p>
          </div>

          <div class="campo">
            <span class="campo-label">{{"GLOBAL.TELEFONE" | translate}}</span>
            <p>{{ formatarTelefone(pessoa.telefone) }}</p>
          </div>

          <div class="campo">
            <span class="campo-label">{{"GLOBAL.DATA_INCLUSAO_CLIENTE" | translate}}</span>
            <p>{{ formatarData(pessoa.dataInclusao?.toString()!) }}</p>
          </div>

          @if (pessoa.sexo) {
          <div class="campo">
            <span class="campo-label">{{"GLOBAL.SEXO" | translate}}</span>
            <p>
              @switch (pessoa.sexo) {
                @case (1) { {{ 'GLOBAL.SEXO_MASCULINO' | translate }} }
                @case (2) { {{ 'GLOBAL.SEXO_FEMININO' | translate }} }
                @default { {{ 'GLOBAL.SEXO_NAO_INFORMADO' | translate }} }
              }
            </p>
          </div>
          }
        </div>

        <!-- Endereço (se disponível) -->
        @if (pessoa.endereco) {
        <div class="endereco-section">
          <h3><i class="pi pi-map-marker"></i> {{"PESSOAS_MODAL_DETALHE.ENDERECO" | translate}}</h3>
          <div class="dados-grid">
            <div class="campo">
              <span class="campo-label">{{"GLOBAL.LOGRADOURO" | translate}}</span>
              <p>
                {{ pessoa.endereco.logradouro }}, {{ pessoa.endereco.numero }}
              </p>
            </div>

            <div class="campo">
              <span class="campo-label">{{"GLOBAL.COMPLEMENTO" | translate}}</span>
              <p>{{ pessoa.endereco.complemento }}</p>
            </div>

            <div class="campo">
              <span class="campo-label">{{"GLOBAL.BAIRRO" | translate}}</span>
              <p>{{ pessoa.endereco.bairro }}</p>
            </div>

            <div class="campo">
              <span class="campo-label">{{"GLOBAL.CIDADE" | translate}}/{{"GLOBAL.ESTADO" | translate}}</span>
              <p>{{ pessoa.endereco.cidade }} - {{ pessoa.endereco.estado }}</p>
            </div>

            <div class="campo">
              <span class="campo-label">{{"GLOBAL.CEP" | translate}}</span>
              <p>{{ formatarCEP(pessoa.endereco.codPostal) }}</p>
            </div>

            <div class="campo">
              <span class="campo-label">{{"GLOBAL.PAIS" | translate}}</span>
              <p>{{ pessoa.endereco.pais }}</p>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </p-tabPanel>

    <!-- ===== TAB 2: Planos ===== -->
    <p-tabPanel [header]="planosHeader">
      <div class="planos-container">
        <div class="header-section">
          <h3>
            <i class="pi pi-briefcase"></i>
            {{"PESSOAS_MODAL_DETALHE.PLANOS_ASSOCIADOS" | translate}} ({{ $planos().length }})
          </h3>
          <!-- <button pButton icon="pi pi-plus" [label]="'PESSOAS_MODAL_DETALHE.VINCULAR_PLANO' | translate"
            class="p-button-success p-button-sm" (click)="abrirModalVincularPlano()"
            pTooltip="Vincular novo plano ao usuário" aria-label="vincular plano">
          </button> -->
        </div>

        <!-- Tabela de Planos -->
        @if ($planos().length > 0) {
        <p-table [value]="$planos()">
          <ng-template pTemplate="header">
            <tr>
              <th>{{"PESSOAS_MODAL_DETALHE.PLANO" | translate}}</th>
              <th>{{"PESSOAS_MODAL_DETALHE.APLICACAO" | translate}}</th>
              <th>{{"PESSOAS_MODAL_DETALHE.STATUS" | translate}}</th>
              <!-- <th>{{"PESSOAS_MODAL_DETALHE.ACAO" | translate}}</th> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-plano>
            <tr>
              <td>{{ plano.nome }}</td>
              <td>{{ plano.aplicacao === 1 ? 'Nomoh' : 'Bardo' }}</td>
              <td>
                <p-tag [value]="plano.status ? 'Ativo' : 'Inativo'"
                  [severity]="plano.status ? 'success' : 'warning'"></p-tag>
              </td>
              <!-- <td>
                <button pButton icon="pi pi-trash" class="p-button-danger p-button-sm" (click)="removerPlano(plano.id)"
                  [pTooltip]="'PESSOAS_MODAL_DETALHE.DESVINCULAR_PLANO' | translate" aria-label=""></button>
              </td> -->
            </tr>
          </ng-template>
        </p-table>
        }

        <!-- Estado Vazio -->
        @if ($planos().length === 0) {
        <div class="empty-state">
          <i class="pi pi-inbox"></i>
          <p>{{"PESSOAS_MODAL_DETALHE.NENHUM_PLANO" | translate}}</p>
        </div>
        }
      </div>
    </p-tabPanel>

    <!-- ===== TAB 3: Permissões Extras ===== -->
    @if (showPermissionsTab) {
    <p-tabPanel [header]="permissoesExtrasHeader">
      <lib-pessoa-permissions-extras-tab [userId]="pessoaId" [canEdit]="canEditPermissions">
      </lib-pessoa-permissions-extras-tab>
    </p-tabPanel>
    }
  </p-tabView>
  }

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="fechar()">
      {{ 'GLOBAL.FECHAR' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Modal Vincular Plano -->
<p-dialog
  [visible]="$mostrarModalVincular()"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: 'min(500px, 95vw)' }"
  [breakpoints]="{ '960px': '95vw', '640px': '100vw' }"
  [header]="'PESSOAS_MODAL_DETALHE.VINCULAR_PLANO' | translate"
  styleClass="n-dialog"
  (visibleChange)="fecharModalVincular($event)"
>

  <div class="vincular-plano-content">
    <p class="info-message">
      <i class="pi pi-info-circle"></i>
      {{"PESSOAS_MODAL_DETALHE.VINCULAR_PLANO_INFO" | translate}}
    </p>

    <div class="campo">
      <span class="campo-label">{{"PESSOAS_MODAL_DETALHE.SELECIONE_PLANO" | translate}}</span>
      <p-dropdown id="planoDropdown" [options]="$planosDisponiveis()" [ngModel]="$planoSelecionado()" optionLabel="nome"
        optionValue="id" [placeholder]="'PESSOAS_MODAL_DETALHE.SELECIONE_PLANO_PLACEHOLDER' | translate" [filter]="true"
        filterBy="nome" [showClear]="true" (onChange)="onPlanoSelecionadoChange($event.value)" appendTo="body">
        <ng-template pTemplate="selectedItem" let-plano>
          @if (plano) {
          <span class="plano-nome">{{ plano.nome }}</span>
          }
        </ng-template>
        <ng-template pTemplate="item" let-plano>
          <span class="plano-nome">{{ plano.nome }}</span>
        </ng-template>
      </p-dropdown>
    </div>

    @if ($planoSelecionado()) {
    @if (verificarSubstituicao($planoSelecionado()!)) {
    <div class="warning-message">
      <i class="pi pi-exclamation-triangle"></i>
      {{"PESSOAS_MODAL_DETALHE.SUBSTITUIR_PLANO_AVISO" | translate}}
    </div>
    }
    }
  </div>

  <ng-template pTemplate="footer">
    <button pButton icon="pi pi-times" aria-label="" label="{{'GLOBAL.CANCELAR' | translate}}" class="p-button-text"
      (click)="fecharModalVincular(false)"></button>
    <button pButton icon="pi pi-check" aria-label="" label="{{'GLOBAL.VINCULAR' | translate}}" class="p-button-success"
      (click)="vincularPlano()" [disabled]="!$planoSelecionado()"></button>
  </ng-template>
</p-dialog>